import { render, staticRenderFns } from "./coversation-tag-multi-select.vue?vue&type=template&id=41f79950&"
import script from "./coversation-tag-multi-select.vue?vue&type=script&lang=js&"
export * from "./coversation-tag-multi-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports